import firebase from 'firebase/app';
import 'firebase/analytics';

const analytics = firebase.analytics();
const events = {
  view_item: 'view_item',
  bank_validated: 'bank_validated',
  files_validated: 'files_validated',
  generate_lead: 'generate_lead',
};

export {
  events,
  analytics
};
